import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Foter from './Foter';
import Useletter from './Useletter';
function Newmaterial() {
  return (
   <div>
     <Container>
      <Row>
        <Col>
          <img
            src="https://www.junaidjamshed.com/media/wysiwyg/banner_29.jpg"
            alt = ""
            style={{ width: '100%',
                 height: 'auto',
                  objectFit: 'cover',
                marginTop: '70px' }}
          />
        </Col>
      </Row>
    </Container>

    <Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-2.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-13.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>
{/* second container ends here */}

      <Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/stitched_63.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-15.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>

      {/* third container ends here */}


      <Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/catalog/product/2/4/24-1950_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        <p>PINK KHADDI EMBROIDERED 3PC STITCHED</p>
        <h3>PKR 4,890.00</h3>
        </Col>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/catalog/product/2/4/24-1949_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
         <p>OFF WHITE KHADDI EMBROIDERED 3PC STITCHED</p>
         <h3>PKR 3,690.00</h3>
        </Col>

        <Col>
        <img
        src='https://www.junaidjamshed.com/media/catalog/product/2/4/24-1948_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        <p>LILAC KHADDI EMBROIDERED 3PC STITCHE</p>
        <h3>PKR 5,590.00</h3>
        </Col>


        <Col>
        <img
        src='https://www.junaidjamshed.com/media/catalog/product/j/k/jk2-24-5657_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        <p>
        PURPLE DOBBY EMBROIDERED 2PC STITCHED</p>
        <h3>PKR 3,890.00</h3>
        </Col>
      </Row>
      </Container>


      {/* Fourth container ends here */}


      <Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-5.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        <button 
        style={
            {
                width:'120px',
                height:'50px',
                marginTop:'50px',
                backgroundColor: 'black',
                color:'white'
                
            }
        }>3PC Unstiched
            
        </button>
        </Col>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-7.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}
        
        />
        <button 
        style={
            {
                width:'120px',
                height:'50px',
                marginTop:'50px',
                backgroundColor: 'black',
                color:'white'
                
            }
        }>2PC Unstiched
            
        </button>
        </Col>

        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-9.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}
        
      />
        <button 
        style={
            {
                width:'120px',
                height:'50px',
                marginTop:'50px',
                backgroundColor: 'black',
                color:'white'
                
            }
        }>1PC Unstiched
            
        </button>
        </Col>
      </Row>
      </Container>

      <Container>
      <Row>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-12.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-11.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      
    
      </Container>
           <Useletter/>

      <Foter/>



      
   </div>
  )
}

export default Newmaterial;
